import React from 'react';
import Component from '@vfuk/core-sandwich';
const Sandwich = props => {
    return React.createElement(Component, Object.assign({}, props));
};
export default Sandwich;
